import {X} from 'lucide-react';
import * as React from 'react';

type Props = {
  fieldName: string;
  value: string;
  onRemove: () => void;
};

export const FieldPill = (props: Props) => {
  const {fieldName, value, onRemove} = props;

  return (
    <span className="bg-primary/10 text-primary inline-flex h-6 items-center gap-1 rounded-md px-2 text-xs">
      <span className="text-primary/70">{fieldName}:</span>
      <span className="font-medium">{value}</span>
      <button
        type="button"
        onClick={onRemove}
        className="ml-0.5 rounded hover:bg-primary/20"
      >
        <X className="h-3 w-3" />
      </button>
    </span>
  );
};
